import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { NameResult } from "../types/NameResult";

export interface SavedSession {
  id: string;
  keywords: string[];
  tone: string;
  length: string;
  tlds: string[];
  strategy?: string[];
  results: NameResult[];
  createdAt: number;
}

const STORAGE_KEY = "namin8_sessions";

export function useSavedSessions() {
  const [sessions, setSessions] = useState<SavedSession[]>([]);

  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      try {
        setSessions(JSON.parse(raw));
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, []);

  const saveSession = (session: Omit<SavedSession, "id" | "createdAt">) => {
    const newSession: SavedSession = {
      ...session,
      id: uuidv4(),
      createdAt: Date.now(),
    };
    const updated = [newSession, ...sessions];
    setSessions(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  const deleteSession = (id: string) => {
    const updated = sessions.filter((s) => s.id !== id);
    setSessions(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  return { sessions, saveSession, deleteSession };
}
